import {
	LazyAfterPaintBackgroundScripts,
	LazyForPaintBackgroundScripts,
} from '@atlassian/jira-dashboard-background-scripts/src/async.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component';

export const DashboardBackgroundScripts = componentWithFG(
	'jira_dashboards_optimise_atf_gadgets_loading',
	LazyForPaintBackgroundScripts,
	LazyAfterPaintBackgroundScripts,
);

DashboardBackgroundScripts.displayName = 'ConditionalDashboardBackgroundScripts';
